import {Chip} from "@mui/material";
import React from "react";
import {PlSentStatus} from "../../app/api/model/device";
import {useTranslation} from "react-i18next";

const PlSentStatusChip = ({status}: {status: PlSentStatus}) => {
    const {t} = useTranslation();
    switch (status) {
        case PlSentStatus.PENDING:
            return <Chip label={t("plSent_statusPending")} color={"info"} />;
        case PlSentStatus.REGISTERED:
            return <Chip label={t("plSent_statusRegistered")} color={"success"} />;
        case PlSentStatus.FAILED:
            return <Chip label={t("plSent_statusFailed")} color={"error"} />;
        case PlSentStatus.UNREGISTERED:
        default:
            return <Chip label={t("plSent_statusUnregistered")} color={"warning"} variant="outlined" />;
    }
};

export default PlSentStatusChip;
